


























import { OrgsApi, ProductsApi, VatsApi, WaterExport, WaterExportsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import { Component, Vue } from 'vue-property-decorator';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
		routerLinkButton,
	},
})
export default class ProductsList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'product.name', label: 'Product', sortable: false },
			{ key: 'status', sortable: true },
			{ key: 'product.site.name', label: 'Site', sortable: false },
			{ key: 'consentIdentifier', label: 'Export ID', sortable: true },
			{ key: 'targetorg.name', label: 'Council', sortable: false },
			{ key: 'product.consent.consentIdentifier', label: 'Consent ID', sortable: false },
			{ key: 'product.faultStatus', label: 'Fault Status', sortable: true },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Status',
			field: 'status',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Enabled', value: 'enabled' },
				{ text: 'Internal Only', value: 'internalOnly' },
				{ text: 'Disabled', value: 'disabled' },
			],
		},
		{
			label: 'Council',
			field: 'targetOrgId',
			value: [],
			type: 'checkboxes',
			options: [],
		},
	];

	public searchBy = { value: 'custom' };
	private waterExportsApi: WaterExportsApi;
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
		this.waterExportsApi = new WaterExportsApi();
	}
	public created() {
		this.getExportTargets();
	}
	public reload() {
		this.$root.$emit('bv::refresh::table', 'water-exports-datatable');
	}

	public clickTable(item: WaterExport, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: `products.water.view`,
				params: { productId: item.productId },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: `products.water.view`,
				params: { productId: item.productId },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});

			if (this.state.search) {
				filters.push({ field: 'custom', value: this.state.search });
			}

			const response = await this.waterExportsApi.waterExportsGet(
				ApiUtils.queryOptions(filters, ctx, {
					params: { include: 'targetorg,product,product.consent,product.site' },
				}),
			);
			const respData = response.data.data || [];

			this.state.totalRows = response.data.meta.total || 0;
			return respData;
		} catch (e) {
			console.error(e);
			this.state.totalRows = 0;
			return [];
		}
	}

	public async getExportTargets() {
		try {
			const response = await new OrgsApi().orgGetFtpTargets();

			this.filters[1].options = response.data.data.map(org => {
				return { text: org.name, value: org.id };
			});
		} catch (e) {
			console.log(e);
		}
	}
}
